import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root'
})
export class ContenusService {

  constructor(private http: HttpClient, private tokenService :  TokenService) { }

  /**
   * Récupère les contenus actuels d'une PTL
   */
  recupererCurrentContenus(idModeration: number) {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/ptl/contenus/" + idModeration;
    return this.http.get(request, {headers: httpHeaders});
  }

  recupererContenusCq(idModeration: number) {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/ptl/contenus/cq/" + idModeration;
    return this.http.get(request, {headers : httpHeaders});
  }

  /**
   * 
   * @param typeContenu 
   * Récupère les motifs d'erreurs possible pour les contenus
   */
  recupererListeMotifs(typeContenu : number, traitement : number) {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/ptl/contenus/liste-erreurs/" + typeContenu + "?traitement=" + traitement;
    return this.http.get(request, {headers: httpHeaders});
  } 

  /**
   * Validation d'un traitement
   */
  validerTraitement(options: Object) {
    let httpHeaders = this.tokenService.loadToken();
    var request = "/api/ptl/traitement";
    var jsonObject = {options : options}
    return this.http.post(request, jsonObject, {headers : httpHeaders, });
  }

  recupererEtatsAnterieurs(options : Object) {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/ptl/contenus/etats-anterieurs?options=" + escape(JSON.stringify(options));
    return this.http.get(request, {headers : httpHeaders});
  }


  envoyerMail(options : Object) {
    let httpHeaders = this.tokenService.loadToken();
    let request = '/api/ptl/contenus/doute?options=' + escape(JSON.stringify(options));
    return this.http.post(request, {}, {headers: httpHeaders});
  }
}
